<template>
  <section
    id="voice"
    class="te-bg-mentor-voice-image bg-cover bg-center py-20 pb-10"
  >
    <h2 class="co-heading-2-caption text-white">
      メンターの声
    </h2>
    <p class="mb-[3.25rem] text-center text-co-gray-50">
      実際のメンターの生の声をご紹介。
    </p>
    <div class="px-5">
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="1"
        :space-between="32"
        :breakpoints="{
          '992': {
            slidesPerView: 2,
          },
        }"
        :pagination="{
          clickable: true,
        }"
        class="mx-auto max-w-full !px-px lg:max-w-[70rem]"
      >
        <SwiperSlide
          :key="1"
          class="!h-auto"
        >
          <div class="mb-5 h-full bg-co-gray-50 p-6 sm:p-10 md:p-[3.25rem]">
            <h3 class="te-slick-mentor-title mb-4 border-b-2 border-co-info-500 pb-2 md:mb-7">
              自分もまた成長できている実感にやりがいを感じています
            </h3>
            <div class="flex flex-col md:flex-row-reverse">
              <p class="co-display-12 m-0">
                メンターの仕事は人間相手なので、受講生が「できました！」「転職決まりました！」との報告を送ってくれた時、コードを書いていた仕事とはまた違った達成感を味わっています。受講生との関わり方で自分もまた大きく成長できている実感にやりがいを感じています。
              </p>
              <div class="mt-4 flex min-w-[6.5rem] justify-center sm:mr-7 md:mt-0">
                <img
                  src="~/assets/images/Te/TeJob/MentorSlider/mentor-machida.jpg"
                  class="te-slick-mentor-image rounded-full"
                  alt="Ko Machida"
                  loading="lazy"
                >
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="2"
          class="!h-auto"
        >
          <div class="mb-5 h-full bg-co-gray-50 p-6 sm:p-10 md:p-[3.25rem]">
            <h3 class="te-slick-mentor-title mb-4 border-b-2 border-co-info-500 pb-2 md:mb-7">
              受講生の夢を支えることにとてもやりがいを感じています
            </h3>
            <div class="flex flex-col md:flex-row-reverse">
              <p class="co-display-12 m-0">
                メンターに支えられた、とても充実していた、最後まで諦めることなく取り組めた、貴重な話しを聞けた、といった言葉を受講終了後にいただくことが多くあり、「エンジニアになりたい」という受講生の夢を支えることにとてもやりがいを感じています。
              </p>
              <div class="mt-4 flex min-w-[6.5rem] justify-center sm:mr-7 md:mt-0">
                <img
                  src="~/assets/images/Te/TeJob/MentorSlider/mentor-ota-jun.jpg"
                  class="te-slick-mentor-image rounded-full"
                  alt="Jun Ota"
                  loading="lazy"
                >
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide
          :key="3"
          class="!h-auto"
        >
          <div class="mb-5 h-full bg-co-gray-50 p-6 sm:p-10 md:p-[3.25rem]">
            <h3 class="te-slick-mentor-title mb-4 border-b-2 border-co-info-500 pb-2 md:mb-7">
              受講生が成長していく姿を見るのもすごく面白いです
            </h3>
            <div class="flex flex-col md:flex-row-reverse">
              <p class="co-display-12 m-0">
                受講生から感謝の言葉をいただけることがやりがいになっています。「こんなに教えてくれて嬉しい！」といったことを言ってもらえて、関わる期間は短いけれど受講生が短期間で成長していく姿を見るのもすごく面白いです。 微力ながらもIT業界・社会貢献できてるかなと思っています。
              </p>
              <div class="mt-4 flex min-w-[6.5rem] justify-center sm:mr-7 md:mt-0">
                <img
                  src="~/assets/images/Te/TeJob/MentorSlider/mentor-nakagawa-akira.jpg"
                  class="te-slick-mentor-image rounded-full"
                  alt="Akira Nakagawa"
                  loading="lazy"
                >
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </section>
</template>

<style scoped>
@import url('~/assets/css/Te/TeCommon/TeCommonSwiper.css');

.te-bg-mentor-voice-image {
  background-image: url('~/assets/images/Te/TeJob/MentorSlider/meetup-voice-bg.jpg');
}

.te-slick-mentor-title {
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.5em;
}

@media (min-width: 768px) {
  .te-slick-mentor-title {
    font-size: 1.25rem;
    font-weight: normal;
  }
}

.te-slick-mentor-image {
  width: 100px;
  height: 100px;
}
</style>
